import { NgModule } from '@angular/core';
import { PreviewDetailsComponent } from './components/preview-details/preview-details.component';
import { PreviewHeaderComponent } from './components/preview-header/preview-header.component';
import { PreviewHierarchyComponent } from './components/preview-hierarchy/preview-hierarchy.component';
import { PeoplePreviewPopupComponent } from './components/people-preview-popup/people-preview-popup.component';
import { PeoplePreviewContainerComponent } from './components/people-preview-container/people-preview-container.component';
import { PeoplePreviewComponent } from './components/people-preview.component';
import { HierarchyModule } from 'src/app/bar/components/hierarchy/hierarchy.module';
import { PreviewModule } from '../preview.module';
import { PeopleService } from './services/people.service';
import { PreviewResultItemComponent } from './components/preview-results/preview-result-item/preview-result-item.component';
import { PreviewResultsComponent } from './components/preview-results/preview-results.component';

const components = [
  PeoplePreviewComponent,
  PreviewHeaderComponent,
  PreviewResultsComponent,
  PreviewHierarchyComponent,
  PreviewDetailsComponent,
  PreviewResultItemComponent,
  PeoplePreviewPopupComponent,
  PeoplePreviewContainerComponent,
];
@NgModule({
  declarations: components,
  imports: [HierarchyModule, PreviewModule],
  providers: [PeopleService],
  exports: components,
})
export class PeoplePreviewModule {}
